import { PipeTransform, Pipe } from '@angular/core';
import { ChequeDetailVM } from '@app/models/cheque/chequevm';
import { BillingSettlementModel } from '@app/models/Merchant-transaction-model/merchant-outletwise-txn-model';

@Pipe({
    name: 'Paymentfilter'
})
export class FilterPipe implements PipeTransform {
//     transform(items: ChequeDetailVM[], searchTerm: string): ChequeDetailVM[] {
//         if (!items || !searchTerm) {
//             return items;
//         }
//         return items.filter(item =>{
//             if(item.Compare==1){
//             if(item.CustomerCode.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
//             {
//                 return true;
//             }
//         }
//         if(item.Compare==2){
//             if(item.Name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
//             {
//                 return true;
//             }
//         }
//         // if(item.Compare==3){
//         //     if(item.BankName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
//         //     {
//         //         return true;
//         //     }
//         // }
//             return false;
//         })
    
// }
transform(items: BillingSettlementModel[], searchTerm: string): BillingSettlementModel[] {
    if (!items || !searchTerm) {
        return items;
    }
    return items.filter(item =>{
      
            if(item.PaymentDate.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
            {
                return true;
            }
            if(item.TerminalId.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
            {
                return true;
            }
            if(item.BatchId.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
            {
                return true;
            }
            if(item.SettlementId.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
            {
                return true;
            }
            if(item.MDR.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
            {
                return true;
            }
    })
        //item.CardNumber.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
} 
}


// WEBPACK FOOTER //
// ./src/app/pipes/searchFilter.pipe.ts